export default __webpack_public_path__ + "static/line-qrcode-b709d83fa62fce1384e687917699bb47.png";